import type { CABIN_CLASS_TYPE } from '../types.ts'

export type MapFlightCabinClassFromUrlQueryParams = {
  value: string | string[] | undefined
}

/** True when `cabinClass` is present with at least one non-empty string (e.g. SETI impression gating). */
export function hasFlightCabinClassQueryParam({ value }: MapFlightCabinClassFromUrlQueryParams): boolean {
  if (value === undefined) {
    return false
  }
  const candidates = Array.isArray(value) ? value : [value]
  return candidates.some((s) => typeof s === 'string' && s.trim() !== '')
}

const normalizedKeyToCabin: Record<string, CABIN_CLASS_TYPE> = {
  economy: 'Economy',
  premiumeconomy: 'Premium Economy',
  business: 'Business',
  first: 'First',
}

/**
 * Maps deep-link `cabinClass` query values to flight form {@link CABIN_CLASS_TYPE}.
 * Supported aliases: economy, premiumEconomy (any casing), premium economy, business, first.
 */
export function mapFlightCabinClassFromUrlQuery({
  value,
}: MapFlightCabinClassFromUrlQueryParams): CABIN_CLASS_TYPE | undefined {
  if (value == null) {
    return undefined
  }
  const raw = Array.isArray(value) ? value[0] : value
  if (typeof raw !== 'string') {
    return undefined
  }
  const trimmed = raw.trim()
  if (!trimmed) {
    return undefined
  }
  const normalized = trimmed.toLowerCase().replace(/\s+/g, '')
  return normalizedKeyToCabin[normalized]
}
